//WE.Flow.Html.Contracts.Manifests.ScriptPathConfig

export class ScriptPathConfig {
    key: string = "";
    path: string = "";
}
